<template>
  <div class="tx-count d-flex flex-column align-items-center px-1 py-0 rounded">
    <strong class="m-0">Hace:</strong>
    <p class="m-0 text-center" style="width: max-content;">{{ time }}</p>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class TimeCount extends Vue {
  @Prop(String) readonly time!: string
}

</script>

<style lang="sass" scoped>
.tx-count
    background: #DBEFDC
    width: 70px
    strong
        margin-bottom: -5px !important
        font-size: 12px !important
    p
        font-size: 14px !important
        margin: 0px !important
        text-align: center
</style>
